/**
 * ProductTypeService
 * Service for ProductType entity operations
 * Route: api/product-types
 * Controller: ProductTypesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProductTypeService
 * Handles product type CRUD operations and lookups
 */
export class ProductTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProductTypeService.DEFAULT_SERVICE_PATH,
            basePath: ProductTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== ACTIVE TYPES ====================
    /**
     * Get active product types
     * GET /api/product-types/active
     * @returns Array of active product types
     */
    async getActive() {
        const response = await this.getActiveRaw();
        return response.data ?? [];
    }
    /**
     * Get active product types (raw)
     * @returns ResponseData with active product types
     */
    getActiveRaw() {
        const endpoint = this.getEndpoint('active', 'active');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
ProductTypeService.DEFAULT_SERVICE_PATH = 'products';
ProductTypeService.BASE_PATH = 'api/product-types';
//# sourceMappingURL=ProductTypeService.js.map